var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "title pb-1 mb-3" }, [_vm._v(_vm._s(_vm.title))]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row" },
      _vm._l(_vm.inputs, function(inputData) {
        return _c(
          "div",
          { key: inputData.id, staticClass: "pb-3", class: _vm.columnClass },
          [
            _c("div", { staticClass: "d-flex" }, [
              _c("div", { staticClass: "checkbox-wrapper" }, [
                _c("input", {
                  staticClass: "checkbox-hover",
                  attrs: { type: "checkbox", disabled: inputData.default },
                  domProps: { checked: inputData.subscribed },
                  on: {
                    click: function($event) {
                      return _vm.toggleCheckbox(inputData)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "checkbox-hover",
                  on: {
                    click: function($event) {
                      return _vm.toggleCheckbox(inputData)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n          " + _vm._s(inputData.title) + "\n        "
                  )
                ]
              )
            ])
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-957d7516", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-957d7516","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/newsByInterests/EditInterestsInputGroup.vue
// module id = null
// module chunks = 